export default {
  state: {
    categories: [],
    tk_it:[],
    tkcategories:[]
  },
  getters: {},
  mutations: {
    setCategories(state, val) {
      state.categories = val;
    },
    setTK_it(state,val){
      state.tk_it = val;
    },
    setTKCategories(state, val) {
      state.tkcategories = val;
    },
  },
  actions: {
    async getCategories({ commit, state }) {
      return new Promise(resolve => {
        if (state.categories && state.categories.length > 0) {
          resolve(state.categories);
        } else {
          this.$axios.get("/app/api/jobcategory/listByProductId?productId=1001").then(res => {
            commit("setCategories", res.data);
            resolve(res.data);
          });
        }
      });
    },
    async getTk_it({ commit, state }) {
      return new Promise(resolve => {
        if (state.tk_it && state.tk_it.length > 0) {
          resolve(state.tk_it);
        } else {
          this.$axios.get("/json/tk_it.json").then(list => {
            commit("setTK_it", list);
            resolve(list);
          });
        }
      });
    },
    async getTKCategories({ commit, state }) {
      return new Promise(resolve => {
        if (state.tkcategories && state.tkcategories.length > 0) {
          resolve(state.tkcategories);
        } else {
          this.$axios.get("https://qihuibao.oss-cn-beijing.aliyuncs.com/public/json/taikangzhiye.json").then(res => {
            commit("setTKCategories", res);
            resolve(res);
          });
        }
      });
    },
  }
};
